import React from "react";
import styles from "./Table.module.sass";
import cn from "classnames";
import Row from "./Row";

const Table = ({ items, onJustify, onUnjustify }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.table}>
        <div className={cn(styles.row, styles.header)}>
          <div className={styles.col}>Séance</div>
          <div className={styles.col}>Formateur</div>
          <div className={styles.col}>Date</div>
          <div className={styles.col}>Horaires</div>
          <div className={styles.col}>Justification</div>
          <div className={styles.col}>Actions</div>
        </div>
        {items.map((item, index) => (
          <Row 
            item={item} 
            key={item.id || index}
            onJustify={onJustify}
            onUnjustify={onUnjustify}
          />
        ))}
      </div>
    </div>
  );
};

export default Table;
